/**
 * First we will load all of this package's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import {sign} from "chart.js/helpers";

require('./timer');
require('./bootstrap');
require('./helpers');
require('./models');
window.hdate = require('./vendor/humandate.js');

window.has_mobile_layout = false;

window.isUsingMobileLayout = function(){
    var browserWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return browserWidth < 830;
};

$(document).ready(function(){
    window.has_mobile_layout = window.isUsingMobileLayout();
    $(window).on('resize',_.debounce(function(){
        window.has_mobile_layout = window.isUsingMobileLayout();
    },500));
});

// START of Loris' happy place.

window.Http = require('./services/Http.js').default;
window.Form = require('./services/Form.js').default;
window.Bus = require('./services/Bus.js').default;
window.Notifications = require('./services/Notifications.js').default;
window.User = require('./services/User.js').default;

if (window.register_user) {
    window.User.register();
}

document.onvisibilitychange = () => {
    if (document.visibilityState === "hidden") {
        window.User.active = false
    } else {
        window.User.active = true
        window.User.renew()
    }
};


import Vue from 'vue';
import registerPlugins from './plugins';
registerPlugins(Vue);
// END of Loris' happy place.

Vue.config.devtools = process.env.NODE_ENV === 'development';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// TODO: Remove when everything is using the Bus service.
window.eventBus = new Vue();

window.closeContextualNavigation = function () {
    backOutOfNestedMenu();
    var $appContent = $("#app-content");
    var $contextualNavigationTrigger = $("#contextual-navigation-trigger");

    $contextualNavigationMobile.removeClass('open');
    $contextualNavigationTrigger.removeClass('menu-open');
};
window.backOutOfNestedMenu = function () {
    var $contextualNavigationMobile = $("#app-contextual-navigation-mobile");

    $contextualNavigationMobile.find('ul li').removeClass('dropdown-open');
    $contextualNavigationMobile.find('>ul>li').css('display', 'block');
    $contextualNavigationMobile.find('>ul>li>a').css('display', 'block');
    $contextualNavigationMobile.find('>ul>li>ul').css('display', 'none');
    $('#contextual-menu-nested-back-button').removeClass('visible');
    $('#mobile-menu-button').removeClass('contextual-back-button-present');
};

window.playNotificationAudio = function(){
    // var audio = new Audio("/audio/your_turn.mp3");
    // audio.play();
}

const app = new Vue({
    el: '#app',
    methods: {
        emitEventFromPush: function (pushPayload) {
            var that = this;
            var signatures = pushPayload.signatures;
            var userId = appData.user.id;

            _.forEach(signatures, function (signature) {
                if (_.startsWith(signature, 'livechat_processor') && _.endsWith(signature, '_' + userId)) {
                    eventBus.$emit('chat-updated');
                    eventBus.$emit('message-received');
                }

                if(_.startsWith(signature, 'user_now_controls_estimate__')){
                    let userIdAndEstimateId = signature.replace('user_now_controls_estimate__','').split('_');
                    console.log(parseInt(userIdAndEstimateId[0],10),parseInt(userIdAndEstimateId[1],10),appData.user.id)
                    if(parseInt(userIdAndEstimateId[0],10) !== appData.user.id){
                        eventBus.$emit('estimate-refresh-required',parseInt(userIdAndEstimateId[1],10));
                    }
                }

                if (_.startsWith(signature, 'notifications_processor')) {
                    eventBus.$emit('new-notification');
                    // window.playNotificationAudio();
                }
            });
        },
        sendToComponents: function (messageName) {
            eventBus.$emit('contextual-navigation-' + messageName);
            window.closeContextualNavigation();
        }
    },
    mounted: function () {
        let that = this;

        /*
        if(workingEnvironment == 'production'){
            if (!_.isUndefined(appUrls) && _.isObject(appUrls) && _.isObject(appUrls.push)) {
                var socket = require('socket.io-client')(appUrls.push.url + ":" + appUrls.push.port);
                socket.on('message', function (data) {
                    var payload = JSON.parse(data);
                    that.emitEventFromPush(payload);
                });
            }
        }
        */
        window.eventBus.$on('functional-tab-closed', function () {
            $('#functional-tabs').removeClass('tab-open');
        });
        window.eventBus.$on('functional-tab-opened', function () {
            $('#functional-tabs').addClass('tab-open');
        });
    }
});

$('body').on('click', function (e) {
    window.eventBus.$emit('body-clicked', e);
});
$(document).ready(function () {
    $('a.post').on('click', function (e) {
        e.preventDefault();
        let url = $(this).attr('href');
        let token = document.head.querySelector('meta[name="csrf-token"]');
        if (token) {
            $.form(url, {csrf_token: token.content}, 'POST').submit();
        } else {
            console.error('Cannot POST to "' + url + '": No CSRF token found in meta tags.');
        }

    });
});


require('./layout/sticky-hambro-headers');
require('./layout/contextual-menu');
require('./layout/main-menu');
require('./layout/header-search');
require('./layout/remove-url-mobile');

window.jQuery = $;
window.parseMoney = function(string){
    return parseFloat(string.replace(',','').replace('£',''));
}
